import React from 'react';
import { Card } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Button } from '../../components/ui/Button';
import { TrendingUp, TrendingDown, DollarSign, Truck, Clock, CheckCircle, Star, Award, Download, Calendar } from 'lucide-react';
export function LogisticsPerformance() {
  const monthlyStats = [{
    month: 'Jul',
    shipments: 980,
    onTime: 97.2,
    revenue: 38
  }, {
    month: 'Agu',
    shipments: 1050,
    onTime: 97.8,
    revenue: 41
  }, {
    month: 'Sep',
    shipments: 1150,
    onTime: 98.1,
    revenue: 43
  }, {
    month: 'Okt',
    shipments: 1247,
    onTime: 98.5,
    revenue: 45
  }];
  const topDrivers = [{
    name: 'Ahmad Yani',
    shipments: 156,
    onTime: 99.2,
    rating: 4.9,
    revenue: 5200000
  }, {
    name: 'Budi Santoso',
    shipments: 142,
    onTime: 98.8,
    rating: 4.8,
    revenue: 4800000
  }, {
    name: 'Joko Widodo',
    shipments: 138,
    onTime: 98.5,
    rating: 4.7,
    revenue: 4600000
  }, {
    name: 'Siti Nurhaliza',
    shipments: 125,
    onTime: 97.9,
    rating: 4.6,
    revenue: 4200000
  }];
  return <div className="space-y-6" data-id="element-2468">
      {/* Header */}
      <div className="flex items-center justify-between" data-id="element-2469">
        <div data-id="element-2470">
          <h2 className="text-2xl font-bold text-slate-900" data-id="element-2471">
            Performance Analytics
          </h2>
          <p className="text-sm text-slate-500 mt-1" data-id="element-2472">
            Monitor performa dan KPI logistik
          </p>
        </div>
        <div className="flex gap-2" data-id="element-2473">
          <select className="px-4 py-2 rounded-lg border border-slate-200 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-2474">
            <option data-id="element-2475">Last 6 Months</option>
            <option data-id="element-2476">Last 12 Months</option>
            <option data-id="element-2477">Year to Date</option>
          </select>
          <Button variant="primary" size="sm" icon={<Download className="w-4 h-4" data-id="element-2479" />} data-id="element-2478">
            Export Report
          </Button>
        </div>
      </div>

      {/* KPI Cards */}
      <div className="grid grid-cols-4 gap-4" data-id="element-2480">
        <Card className="p-5 bg-gradient-to-br from-blue-50 to-blue-100 border-blue-200" data-id="element-2481">
          <div className="flex items-center justify-between mb-3" data-id="element-2482">
            <div className="w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center shadow-lg" data-id="element-2483">
              <Truck className="w-6 h-6 text-white" data-id="element-2484" />
            </div>
            <Badge className="bg-blue-200 text-blue-800 border-0" data-id="element-2485">+8%</Badge>
          </div>
          <p className="text-sm text-blue-700 mb-1" data-id="element-2486">Total Shipments</p>
          <p className="text-4xl font-bold text-blue-900" data-id="element-2487">1,247</p>
          <p className="text-xs text-blue-600 mt-1" data-id="element-2488">Bulan ini</p>
        </Card>

        <Card className="p-5 bg-gradient-to-br from-green-50 to-green-100 border-green-200" data-id="element-2489">
          <div className="flex items-center justify-between mb-3" data-id="element-2490">
            <div className="w-12 h-12 bg-green-600 rounded-xl flex items-center justify-center shadow-lg" data-id="element-2491">
              <CheckCircle className="w-6 h-6 text-white" data-id="element-2492" />
            </div>
            <Badge className="bg-green-200 text-green-800 border-0" data-id="element-2493">
              +0.4%
            </Badge>
          </div>
          <p className="text-sm text-green-700 mb-1" data-id="element-2494">On-Time Rate</p>
          <p className="text-4xl font-bold text-green-900" data-id="element-2495">98.5%</p>
          <p className="text-xs text-green-600 mt-1" data-id="element-2496">Target: 95%</p>
        </Card>

        <Card className="p-5 bg-gradient-to-br from-violet-50 to-violet-100 border-violet-200" data-id="element-2497">
          <div className="flex items-center justify-between mb-3" data-id="element-2498">
            <div className="w-12 h-12 bg-violet-600 rounded-xl flex items-center justify-center shadow-lg" data-id="element-2499">
              <DollarSign className="w-6 h-6 text-white" data-id="element-2500" />
            </div>
            <Badge className="bg-violet-200 text-violet-800 border-0" data-id="element-2501">
              +9%
            </Badge>
          </div>
          <p className="text-sm text-violet-700 mb-1" data-id="element-2502">Revenue</p>
          <p className="text-4xl font-bold text-violet-900" data-id="element-2503">Rp 45Jt</p>
          <p className="text-xs text-violet-600 mt-1" data-id="element-2504">Bulan ini</p>
        </Card>

        <Card className="p-5 bg-gradient-to-br from-amber-50 to-amber-100 border-amber-200" data-id="element-2505">
          <div className="flex items-center justify-between mb-3" data-id="element-2506">
            <div className="w-12 h-12 bg-amber-600 rounded-xl flex items-center justify-center shadow-lg" data-id="element-2507">
              <Clock className="w-6 h-6 text-white" data-id="element-2508" />
            </div>
            <Badge className="bg-amber-200 text-amber-800 border-0" data-id="element-2509">
              -0.2d
            </Badge>
          </div>
          <p className="text-sm text-amber-700 mb-1" data-id="element-2510">Avg Delivery Time</p>
          <p className="text-4xl font-bold text-amber-900" data-id="element-2511">2.3</p>
          <p className="text-xs text-amber-600 mt-1" data-id="element-2512">hari</p>
        </Card>
      </div>

      {/* Monthly Trend */}
      <Card className="p-6" data-id="element-2513">
        <h3 className="font-bold text-lg text-slate-900 mb-6" data-id="element-2514">
          Monthly Performance Trend
        </h3>
        <div className="overflow-x-auto" data-id="element-2515">
          <table className="w-full" data-id="element-2516">
            <thead data-id="element-2517">
              <tr className="border-b border-slate-200" data-id="element-2518">
                <th className="text-left py-3 px-4 text-sm font-bold text-slate-700" data-id="element-2519">
                  Bulan
                </th>
                <th className="text-right py-3 px-4 text-sm font-bold text-blue-700" data-id="element-2520">
                  Shipments
                </th>
                <th className="text-right py-3 px-4 text-sm font-bold text-green-700" data-id="element-2521">
                  On-Time Rate
                </th>
                <th className="text-right py-3 px-4 text-sm font-bold text-violet-700" data-id="element-2522">
                  Revenue
                </th>
                <th className="text-right py-3 px-4 text-sm font-bold text-slate-700" data-id="element-2523">
                  Growth
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-2524">
              {monthlyStats.map((stat, i) => {
              const prevShipments = i > 0 ? monthlyStats[i - 1].shipments : stat.shipments;
              const growth = ((stat.shipments - prevShipments) / prevShipments * 100).toFixed(1);
              return <tr key={i} className="hover:bg-slate-50" data-id="element-2525">
                    <td className="py-3 px-4 font-medium text-slate-900" data-id="element-2526">
                      {stat.month} 2023
                    </td>
                    <td className="py-3 px-4 text-right font-medium text-blue-600" data-id="element-2527">
                      {stat.shipments.toLocaleString()}
                    </td>
                    <td className="py-3 px-4 text-right font-medium text-green-600" data-id="element-2528">
                      {stat.onTime}%
                    </td>
                    <td className="py-3 px-4 text-right font-medium text-violet-600" data-id="element-2529">
                      Rp {stat.revenue}Jt
                    </td>
                    <td className="py-3 px-4 text-right" data-id="element-2530">
                      {i > 0 && <Badge variant={parseFloat(growth) > 0 ? 'success' : 'neutral'} data-id="element-2531">
                          {parseFloat(growth) > 0 ? <TrendingUp className="w-3 h-3 mr-1" data-id="element-2532" /> : <TrendingDown className="w-3 h-3 mr-1" data-id="element-2533" />}
                          {growth}%
                        </Badge>}
                    </td>
                  </tr>;
            })}
            </tbody>
          </table>
        </div>
      </Card>

      {/* Top Drivers & Detailed Metrics */}
      <div className="grid grid-cols-2 gap-6" data-id="element-2534">
        {/* Top Drivers */}
        <Card className="p-6" data-id="element-2535">
          <div className="flex items-center justify-between mb-6" data-id="element-2536">
            <h3 className="font-bold text-lg text-slate-900" data-id="element-2537">
              Top Performing Drivers
            </h3>
            <Award className="w-6 h-6 text-amber-500" data-id="element-2538" />
          </div>
          <div className="space-y-4" data-id="element-2539">
            {topDrivers.map((driver, i) => <div key={i} className="p-4 bg-slate-50 rounded-lg border border-slate-200" data-id="element-2540">
                <div className="flex items-center justify-between mb-3" data-id="element-2541">
                  <div className="flex items-center gap-3" data-id="element-2542">
                    <div className={`w-10 h-10 rounded-lg flex items-center justify-center text-white font-bold ${i === 0 ? 'bg-amber-500' : i === 1 ? 'bg-slate-400' : i === 2 ? 'bg-orange-600' : 'bg-slate-300'}`} data-id="element-2543">
                      #{i + 1}
                    </div>
                    <div data-id="element-2544">
                      <p className="font-bold text-slate-900" data-id="element-2545">{driver.name}</p>
                      <div className="flex items-center gap-1 mt-1" data-id="element-2546">
                        <Star className="w-3 h-3 text-amber-500 fill-amber-500" data-id="element-2547" />
                        <span className="text-xs text-slate-600" data-id="element-2548">
                          {driver.rating}/5.0
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="grid grid-cols-3 gap-2" data-id="element-2549">
                  <div className="text-center p-2 bg-white rounded" data-id="element-2550">
                    <p className="text-xs text-slate-600" data-id="element-2551">Shipments</p>
                    <p className="text-sm font-bold text-slate-900" data-id="element-2552">
                      {driver.shipments}
                    </p>
                  </div>
                  <div className="text-center p-2 bg-white rounded" data-id="element-2553">
                    <p className="text-xs text-slate-600" data-id="element-2554">On-Time</p>
                    <p className="text-sm font-bold text-green-600" data-id="element-2555">
                      {driver.onTime}%
                    </p>
                  </div>
                  <div className="text-center p-2 bg-white rounded" data-id="element-2556">
                    <p className="text-xs text-slate-600" data-id="element-2557">Revenue</p>
                    <p className="text-sm font-bold text-violet-600" data-id="element-2558">
                      Rp {(driver.revenue / 1000000).toFixed(1)}Jt
                    </p>
                  </div>
                </div>
              </div>)}
          </div>
        </Card>

        {/* Detailed Metrics */}
        <Card className="p-6" data-id="element-2559">
          <h3 className="font-bold text-lg text-slate-900 mb-6" data-id="element-2560">
            Detailed Performance Metrics
          </h3>
          <div className="space-y-4" data-id="element-2561">
            <div data-id="element-2562">
              <div className="flex justify-between items-center mb-2" data-id="element-2563">
                <span className="text-sm text-slate-600" data-id="element-2564">
                  On-Time Delivery Rate
                </span>
                <span className="text-sm font-bold text-green-600" data-id="element-2565">98.5%</span>
              </div>
              <div className="w-full h-2 bg-slate-100 rounded-full overflow-hidden" data-id="element-2566">
                <div className="h-full bg-green-500 rounded-full" style={{
                width: '98.5%'
              }} data-id="element-2567"></div>
              </div>
              <p className="text-xs text-slate-500 mt-1" data-id="element-2568">
                1,229 dari 1,247 pengiriman tepat waktu
              </p>
            </div>

            <div data-id="element-2569">
              <div className="flex justify-between items-center mb-2" data-id="element-2570">
                <span className="text-sm text-slate-600" data-id="element-2571">
                  Customer Satisfaction
                </span>
                <span className="text-sm font-bold text-blue-600" data-id="element-2572">4.8/5.0</span>
              </div>
              <div className="w-full h-2 bg-slate-100 rounded-full overflow-hidden" data-id="element-2573">
                <div className="h-full bg-blue-500 rounded-full" style={{
                width: '96%'
              }} data-id="element-2574"></div>
              </div>
              <p className="text-xs text-slate-500 mt-1" data-id="element-2575">
                Berdasarkan 856 rating dari koperasi
              </p>
            </div>

            <div data-id="element-2576">
              <div className="flex justify-between items-center mb-2" data-id="element-2577">
                <span className="text-sm text-slate-600" data-id="element-2578">
                  Delivery Success Rate
                </span>
                <span className="text-sm font-bold text-violet-600" data-id="element-2579">99.2%</span>
              </div>
              <div className="w-full h-2 bg-slate-100 rounded-full overflow-hidden" data-id="element-2580">
                <div className="h-full bg-violet-500 rounded-full" style={{
                width: '99.2%'
              }} data-id="element-2581"></div>
              </div>
              <p className="text-xs text-slate-500 mt-1" data-id="element-2582">
                1,237 dari 1,247 pengiriman berhasil
              </p>
            </div>

            <div data-id="element-2583">
              <div className="flex justify-between items-center mb-2" data-id="element-2584">
                <span className="text-sm text-slate-600" data-id="element-2585">
                  Fleet Utilization
                </span>
                <span className="text-sm font-bold text-amber-600" data-id="element-2586">87%</span>
              </div>
              <div className="w-full h-2 bg-slate-100 rounded-full overflow-hidden" data-id="element-2587">
                <div className="h-full bg-amber-500 rounded-full" style={{
                width: '87%'
              }} data-id="element-2588"></div>
              </div>
              <p className="text-xs text-slate-500 mt-1" data-id="element-2589">
                26 dari 30 kendaraan aktif
              </p>
            </div>

            <div className="pt-4 border-t border-slate-200" data-id="element-2590">
              <div className="grid grid-cols-2 gap-3" data-id="element-2591">
                <div className="p-3 bg-green-50 rounded-lg border border-green-200" data-id="element-2592">
                  <p className="text-xs text-green-700 mb-1" data-id="element-2593">
                    Avg Response Time
                  </p>
                  <p className="text-xl font-bold text-green-900" data-id="element-2594">18 min</p>
                </div>
                <div className="p-3 bg-blue-50 rounded-lg border border-blue-200" data-id="element-2595">
                  <p className="text-xs text-blue-700 mb-1" data-id="element-2596">Fuel Efficiency</p>
                  <p className="text-xl font-bold text-blue-900" data-id="element-2597">8.5 km/L</p>
                </div>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </div>;
}